export default __webpack_public_path__ + "static/media/i1.eb6e97d0.png";